/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PackageResponseFromJSON, PackageResponseToJSON } from './PackageResponse';
/**
 * Check if a given object implements the PackagesListResponse interface.
 */
export function instanceOfPackagesListResponse(value) {
    if (!('packages' in value) || value['packages'] === undefined)
        return false;
    return true;
}
export function PackagesListResponseFromJSON(json) {
    return PackagesListResponseFromJSONTyped(json, false);
}
export function PackagesListResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'packages': (json['packages'].map(PackageResponseFromJSON)),
    };
}
export function PackagesListResponseToJSON(json) {
    return PackagesListResponseToJSONTyped(json, false);
}
export function PackagesListResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'packages': (value['packages'].map(PackageResponseToJSON)),
    };
}
